import { render, staticRenderFns } from "./ModalAdminConfirm.vue?vue&type=template&id=1c05d7dc&scoped=true"
import script from "./ModalAdminConfirm.vue?vue&type=script&lang=js"
export * from "./ModalAdminConfirm.vue?vue&type=script&lang=js"
import style0 from "./ModalAdminConfirm.vue?vue&type=style&index=0&id=1c05d7dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c05d7dc",
  null
  
)

export default component.exports